module.exports = __webpack_public_path__ + "static/assets/eb58fc5fd9a0dfa9bcf99e2daf265792.png";